module.exports = __webpack_public_path__ + "static/cover-6b5ce098d743540be118d60de53102f6.jpg";